import React, { useEffect } from 'react';
import { initPixel } from './lib/fpixel';
import { TopBanner } from './components/TopBanner';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { Problem } from './components/Problem';
import { Transformation } from './components/Transformation';
import { ForWhom } from './components/ForWhom';
import { MainContent } from './components/MainContent';
import { Gallery } from './components/Gallery';
import { Testimonials } from './components/Testimonials';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { SalesPopup } from './components/SalesPopup';
import { WhatsAppButton } from './components/WhatsAppButton';
export function App() {
  useEffect(() => {
    // Initialize the Meta Pixel and fire the initial PageView once on load.
    initPixel();
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-primary/20 selection:text-primary-dark" data-id="element-0">
      <TopBanner data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <SocialProof data-id="element-4" />
        <Problem data-id="element-5" />
        <Transformation data-id="element-6" />
        <ForWhom data-id="element-7" />
        <MainContent data-id="element-8" />
        <Gallery data-id="element-9" />
        <Testimonials data-id="element-10" />
        <Offer data-id="element-11" />
        <Guarantee data-id="element-12" />
        <FAQ data-id="element-13" />
        <FinalCTA data-id="element-14" />
      </main>

      <footer className="bg-gray-900 text-gray-500 py-8 text-center text-sm" data-id="element-15">
        <div className="max-w-4xl mx-auto px-6" data-id="element-16">
          <p data-id="element-17">
            © {new Date().getFullYear()} Enciclopedia Gluko Libre Argentina.
            Todos los derechos reservados.
          </p>
          <p className="mt-2 text-xs" data-id="element-18">
            Este producto no sustituye el consejo médico profesional. Consulte
            siempre a su médico.
          </p>
        </div>
      </footer>

      <SalesPopup data-id="element-19" />
      <WhatsAppButton data-id="element-20" />
    </div>;
}